import moment from 'moment';
import _ from 'lodash';

import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { ItemMaintenanceEnum, ItemEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { KitchenItemPrepareInHouseFilterEnum } from 'Common/GridHelper';

import * as types from './types';

const INITIAL_STATE = {
  itemDetails: [],
  itemDetailsError: null,
  itemDeleteError: null,
  itemDeleteMessage: null,
  fetching: false,
  deleted: false,
  selectedBidRowIndex: 0,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ITEM_MAINTENANCE_LOADING:
      return {
        ...state,
        fetching: action.payload,
      };

    case types.ITEM_MAINTENANCE_LISTING:
      const itemDetails = action.payload.data.Data;
      return {
        ...state,
        itemDetails: itemDetails.map(item => ({
          ...item,
          [ItemEnum.BeginDate]: item[ItemEnum.BeginDate]
            ? moment(item[ItemEnum.BeginDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.EndDate]: item[ItemEnum.EndDate]
            ? moment(item[ItemEnum.EndDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.PrimaryPrice]: item[ItemEnum.PrimaryPrice]
            ? Number(item[ItemEnum.PrimaryPrice]).toFixed(4)
            : '',
          [ItemMaintenanceEnum.StorageLocationIds]: item[
            ItemMaintenanceEnum.StorageLocationIds
          ]
            ? item[ItemMaintenanceEnum.StorageLocationIds].split(',')
            : '',
          [ItemEnum.PrepareInHouse]: item[ItemEnum.PrepareInHouse]
            ? KitchenItemPrepareInHouseFilterEnum.Yes
            : KitchenItemPrepareInHouseFilterEnum.No,
        })),
      };

    case types.ITEM_MAINTENANCE_CLEAR_ITEMS_GRID: {
      return {
        ...INITIAL_STATE,
      };
    }

    case types.ITEM_MAINTENANCE_LISTING_ERROR:
      const itemDetailsResponse = action.payload.response;
      if (
        _.has(itemDetailsResponse, 'data.Errors') &&
        itemDetailsResponse.data.Errors.length
      ) {
        return {
          ...state,
          itemDetailsError: itemDetailsResponse.data.Errors,
        };
      }
      return {
        ...state,
        itemDetailsError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while fetching items',
        },
      };
    case types.ITEM_MAINTENANCE_DELETE:
      return {
        ...state,
        itemDeleteMessage: action.payload.Data,
        deleted: true,
      };
    case types.ITEM_MAINTENANCE_DELETE_ERROR:
      const itemDeleteResponse = action.payload.response;
      if (
        _.has(itemDeleteResponse, 'data.Errors') &&
        itemDeleteResponse.data.Errors &&
        itemDeleteResponse.data.Errors.length
      ) {
        return {
          ...state,
          itemDeleteError: itemDeleteResponse.data.Errors,
        };
      }
      return {
        ...state,
        itemDeleteError: {
          Title: 'Error',
          Message: 'An error occurred deleting item. Please try again.',
        },
      };
    case types.ITEM_MAINTENANCE_CLEAR_ERRORS:
      return {
        ...state,
        itemDetailsError: null,
        itemDeleteError: null,
        itemDeleteMessage: null,
        deleted: false,
      };

    case types.UPDATE_SELECTED_BID_ROW_INDEX:
      return {
        ...state,
        selectedBidRowIndex: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/itemMaintenance/reducer.js